/* Cart page parity. Uses the existing drawer Trustpilot source; no duplicate rating API call. */
(() => {
  'use strict';
  if (window.__lbdbCartPageInitialized) return;
  window.__lbdbCartPageInitialized = true;
  let page;
  let sourceDrawer;
  let observer;
  let syncPending = false;
  const formatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });

  function updateDelivery() {
    if (!page) return;
    const expected = new Date();
    expected.setDate(expected.getDate() + 8);
    const label = formatter.format(expected);
    const iso = `${expected.getFullYear()}-${String(expected.getMonth() + 1).padStart(2, '0')}-${String(expected.getDate()).padStart(2, '0')}`;
    page.querySelectorAll('[data-cart-footer-delivery]').forEach(block => {
      const time = block.querySelector('[data-cart-delivery-date]');
      if (!time) return;
      time.textContent = label;
      time.setAttribute('datetime', iso);
      block.hidden = false;
    });
  }

  function mirrorRating() {
    if (!page || !sourceDrawer) return;
    const source = sourceDrawer.querySelector('.lbdb-footer-trustpilot__link');
    const target = page.querySelector('.lbdb-footer-trustpilot__link');
    if (!source || !target) return;
    const score = source.querySelector('.lbdb-footer-trustpilot__score');
    const count = source.querySelector('.lbdb-footer-trustpilot__count');
    if (!score || !count || score.hidden || count.hidden || !score.textContent || !count.textContent) return;
    target.querySelector('.lbdb-footer-trustpilot__score').textContent = score.textContent;
    target.querySelector('.lbdb-footer-trustpilot__count').textContent = count.textContent;
    target.querySelectorAll('.lbdb-footer-trustpilot__stars,.lbdb-footer-trustpilot__score,.lbdb-footer-trustpilot__count,.lbdb-footer-trustpilot__sep').forEach(element => { element.hidden = false; });
    if (source.getAttribute('aria-label')) target.setAttribute('aria-label', source.getAttribute('aria-label'));
  }

  function connect() {
    page = document.querySelector('[data-lbdb-cart-page]');
    if (!page) return;
    const current = document.getElementById('cart-drawer');
    if (current !== sourceDrawer) {
      if (observer) observer.disconnect();
      sourceDrawer = current;
      if (sourceDrawer) {
        observer = new MutationObserver(mirrorRating);
        observer.observe(sourceDrawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      }
    }
    mirrorRating();
    updateDelivery();
  }

  function reconcile(cart) {
    if (!page || !cart || !Array.isArray(cart.items)) return;
    const lines = cart.items.map(item => `${item.key}:${item.quantity}|`).join('');
    if (lines !== page.dataset.cartPageLines || String(cart.total_price) !== page.dataset.cartPageTotal) window.location.reload();
  }

  async function refreshCart() {
    if (!page || syncPending) return;
    syncPending = true;
    try {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (!root || !root.startsWith('/') || root.startsWith('//')) return;
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (response.ok) reconcile(await response.json());
    } catch (_) { /* Keep the native cart usable if its read-only refresh fails. */ }
    finally { syncPending = false; }
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest && event.target.closest('#lbdb-add-2nd-coffret-page');
    if (!button || button.disabled || !button.closest('[data-lbdb-cart-page]')) return;
    const variantId = Number(button.dataset.packagingVariant);
    const addUrl = button.dataset.packagingAddUrl;
    if (!Number.isSafeInteger(variantId) || variantId <= 0 || !addUrl || !addUrl.startsWith('/') || addUrl.startsWith('//')) return;
    button.disabled = true;
    const label = button.textContent;
    button.textContent = '…';
    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Gift box unavailable');
      // The full cart page already uses native navigation for quantity changes.
      window.location.reload();
    } catch (_) {
      button.disabled = false;
      button.textContent = label;
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('cart:refresh', refreshCart);
  document.addEventListener('cart:change', event => reconcile(event.detail && event.detail.cart));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) connect(); });
  window.addEventListener('pageshow', connect);
  window.addEventListener('focus', connect);
})();
